export default function PHP_require_once() {
  return (
    <div>
      <h1>PHP_require_once</h1>
    </div>
  );
}
